export default __webpack_public_path__ + "0418e404bf792563e754ee068c54f6ee.woff";